// @flow
import React, { useState } from 'react';
import styled from 'styled-components';

// Material
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grow from '@material-ui/core/Grow';
import Hidden from '@material-ui/core/Hidden';
// import Divider from '@material-ui/core/Divider';

// Custom
import { Label } from '../../label';
import { Message } from '../../text';
import { TrainTimesList, TrainTimesListItem } from './components';
// import SaveTrainButton from '../SaveTrainButton';
import {
  mapStationToStationName,
  mapOperationDateToMessage,
  convertTimeToUsLocale,
  fetchTravelTime,
} from '../../helpers';
import { Props } from './types';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '50%',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      flexBasis: '33.33%',
    },
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    padding: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(3),
  },
  details: {
    flexDirection: 'column',
  },
  message: {
    margin: '0 0 24px',
    fontWeight: '500',
  },
}));

const IconWrapper = styled.div`
  background-color: var(--color-neutral-white);
  border: 3px solid var(--color-brand-primary);
  padding: 3px 4px 1px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
`;

export default function TrainResultItem(props: Props) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const { stops } = props.train;

  let startingPointIndex: number = 0;
  const startingPoint =
    stops.find((stop, index) => {
      if (stop.station === props.startingPoint) {
        startingPointIndex = index;
        return stop;
      } else {
        return false;
      }
    }) || {};
  const endingPoint =
    stops.find(stop => stop.station === props.endingPoint) || {};
  const travelTime = fetchTravelTime(startingPoint, endingPoint);
  const opDateMessage = mapOperationDateToMessage(
    props.train.operation_date || '',
  );

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <ExpansionPanel
      expanded={expanded === `panel-${props.index}`}
      onChange={handleChange(`panel-${props.index}`)}
    >
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${props.index}bh-content`}
        id={`panel-${props.index}-bh-header`}
      >
        <Typography className={classes.heading} component="span">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <IconWrapper
              className={classes.icon}
              aria-label="Narita Express train logo"
            >
              NE
            </IconWrapper>
            <Label
              subtitle="Depart"
              title={convertTimeToUsLocale(startingPoint.time)}
            />
          </div>
        </Typography>
        <Hidden smDown>
          <Typography className={classes.heading} component="span">
            <Label
              subtitle="Arrival"
              title={convertTimeToUsLocale(endingPoint.time)}
            />
          </Typography>
        </Hidden>
        <Typography className={classes.heading} component="span">
          <Label subtitle="Est. travel time" title={travelTime} />
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        {opDateMessage && (
          <Message className={classes.message} color={'#ffc107'}>
            {opDateMessage}
          </Message>
        )}
        <TrainTimesList>
          {stops
            .filter((stop, index) => {
              if (index < startingPointIndex) {
                return false;
              }
              if (stop && endingPoint) {
                return stop.time <= endingPoint.time;
              } else {
                return false;
              }
            })
            .map((stop, i) => {
              return (
                <React.Fragment key={`${stop.name}_${i}`}>
                  <Grow
                    in={expanded ? true : false}
                    style={{ transformOrigin: '50px' }}
                    {...(expanded ? { timeout: 1000 + i * 50 } : {})}
                    unmountOnExit
                  >
                    <TrainTimesListItem>
                      <b>{mapStationToStationName(stop.station)}</b> -{' '}
                      <span>{convertTimeToUsLocale(stop.time)}</span>
                    </TrainTimesListItem>
                  </Grow>
                </React.Fragment>
              );
            })}
        </TrainTimesList>
      </ExpansionPanelDetails>
      {/* <Divider /> */}
      {/* <ExpansionPanelActions>
        <SaveTrainButton train={props.train} />
      </ExpansionPanelActions> */}
    </ExpansionPanel>
  );
}
